import { Group, Stack, Text } from '@mantine/core';
import { BNButton } from '../../../components/Button/Button';
import { useAtomValue } from 'jotai';
import { selectedMergedListingAtom } from '../../../data/atoms';
import { useDeleteApiInventoryListingsListingId } from '../../../api';

export function DeleteListingForm({ onClose }: { onClose: () => void }) {
  const selectedListing = useAtomValue(selectedMergedListingAtom);

  const { mutateAsync, isPending } = useDeleteApiInventoryListingsListingId({
    axios: {
      headers: {
        'x-tenant-id': selectedListing?.tenantId,
      },
    },
  });

  if (!selectedListing?.listingId) {
    return null;
  }

  return (
    <Group gap="xs" align="flex-end" justify="right" mt={-2}>
      <Stack gap="xs">
        <Text>Really delete these tickets?</Text>
        <Group gap="xs" align="flex-end" justify="right" wrap="nowrap" w={236}>
          <BNButton
            fullWidth
            variant="default"
            disabled={isPending}
            size="xs"
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </BNButton>
          <BNButton
            fullWidth
            variant="filled"
            disabled={(selectedListing?.quantityReserved ?? 0) > 0}
            loading={isPending}
            color="red"
            size="xs"
            onClick={async () => {
              await mutateAsync({ listingId: selectedListing.listingId });
              onClose();
            }}
          >
            Delete
          </BNButton>
        </Group>
      </Stack>
    </Group>
  );
}
